exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-34ec4c76]:export{menu-bgc-oragne:#F2C46D}.mainContPage[data-v-34ec4c76]{flex:1}.mainContPage .top-logo[data-v-34ec4c76]{padding-top:20px;padding-bottom:20px;text-align:center}.mainContPage .top-logo img[data-v-34ec4c76]{height:120px}.mainContPage .top-logo.postnord[data-v-34ec4c76]{margin-top:-2px;margin-bottom:15px;background-color:#0d234b;padding:0}.mainContPage .top-logo.postnord img[data-v-34ec4c76]{height:48px}.mainContPage .search-result-box[data-v-34ec4c76]{width:1120px;margin:0 auto}.mainContPage .radio-type[data-v-34ec4c76]{text-align:left;padding-left:230px;box-sizing:border-box;margin-bottom:20px}\n", ""]);

// exports
